var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94141 7.57699L14.9983 10.7739V4.24512L9.94141 7.57699Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.24512V10.7739L5.05688 7.57699L0 4.24512Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0617 2.34375H0.936719C0.468906 2.34375 0.0976562 2.6925 0.0273438 3.14156L7.49922 8.06438L14.9711 3.14156C14.9008 2.6925 14.5295 2.34375 14.0617 2.34375Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08562 8.14303L7.75906 9.01678C7.68031 9.06834 7.59125 9.09365 7.50125 9.09365C7.41125 9.09365 7.32219 9.06834 7.24344 9.01678L5.91687 8.14209L0.03125 11.8649C0.103437 12.3102 0.472812 12.6562 0.93875 12.6562H14.0638C14.5297 12.6562 14.8991 12.3102 14.9713 11.8649L9.08562 8.14303Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.5da0d12395f2cc2ea1d31ebc8f77080d.svg";
export { ForwardRef as ReactComponent };